import { Button, Col, Container, Row } from "react-bootstrap"
import { AppData, RoleData } from "../../api/apps/data"
import { useApps } from "../../api/apps/store"
import useUXStore from "../../api/ux/store"
import ButtonControl from "../../components/ButtonControl"
import Input from "../../components/Input"
import { useEffect, useState } from "react"
import Label from "../../components/Label"
import Loading from "../../components/Loading"
import { ReactComponent as DeleteIcon } from "../../svgs/delete.svg"
import { OWNER_ROLE, ADMIN_ROLE } from "../../constants"

const defaultApp: AppData = {
    id: "",
    name: "",
    desc: ""
}
const defaultRole: RoleData = {}
type RoleItemProps = {
    role: RoleData
    onDelete: (role: RoleData) => void
    editable?: boolean
}

const RoleViewItem: React.FC<RoleItemProps> = ({ role, onDelete, editable = true }) => {
    const [isHovered, setIsHovered] = useState(false)
    const isProtectedRole = role.id === OWNER_ROLE || role.id === ADMIN_ROLE

    return <Row
        className="mx-0"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ alignItems: "center", padding: "5px 0" }}
    >
        <Col sm={2}>{role.name}</Col>
        <Col>{role.id}</Col>
        <Col>{role.desc}</Col>
        <Col sm="auto" style={{ width: "50px" }}>
            {isHovered && !isProtectedRole && editable && (
                <Button
                    size="sm"
                    variant="link"
                    onClick={() => onDelete(role)}
                    style={{
                        padding: "2px",
                        border: "none",
                        background: "transparent"
                    }}
                >
                    <DeleteIcon style={{
                        color: "red",
                        width: "20px",
                        height: "20px",
                        fill: "#dc3545"
                    }} />
                </Button>
            )}
        </Col>
    </Row>
}


const RoleListView = ({ app = defaultApp, editable = true }) => {
    const { retrieveRoles, loadingRoles, currentRoles, addRole, removeRole } = useApps(state => state)
    const [adding, setAdding] = useState(false)
    const [crole, setCRole] = useState({ ...defaultRole })
    useEffect(() => {
        retrieveRoles(app.id!)
    }, [])
    const onRoleAdded = (role: RoleData) => {
        setAdding(true)
        addRole(app.id!, crole)
            .then(code => {
                // TODO: add toast
            })
            .catch(err => {

            })
            .finally(() => setAdding(false))
    }
    const onRoleDelete = (role: RoleData) => {
        removeRole(role.id!)
        // TODO: add toast
    }
    if (loadingRoles)
        return <div style={{ paddingTop: 20, paddingBottom: 20 }}><Loading center={true} /></div>

    return <Container fluid style={{ display: "flex", flexDirection: "column", height: "100%", padding: "1.5rem 1.5rem 1rem 1.5rem" }}>
        <Row className="mx-0" style={{ paddingBottom: 10, flexShrink: 0 }}>
            <Col sm={2}><Label size="medium" padding="">Role</Label></Col>
            <Col><Label size="medium" >Id</Label></Col>
            <Col><Label size="medium" >Description</Label></Col>
            <Col sm="auto"><div style={{ width: 50 }} /></Col>
        </Row>
        <div style={{ flexGrow: 1, overflowY: "auto", overflowX: "hidden", minHeight: 0, paddingRight: "5px", marginBottom: "15px" }}>
            {currentRoles?.map(item => <RoleViewItem key={item.id} role={item} onDelete={onRoleDelete} editable={editable} />)}
        </div>
        {editable && <Row className="mx-0" style={{ padding: "15px 0 5px 0", borderTop: "1px solid #dee2e6", flexShrink: 0 }}>
            <Col><Input placeholder="Role Name"
                disabled={adding}
                onChange={(e: any) => setCRole({ ...crole, name: e.target.value })} /></Col>
            <Col><Input placeholder="Id"
                disabled={adding}
                value={crole.id || ""}
                onChange={(e: any) => setCRole({ ...crole, id: e.target.value.replace(/[^a-zA-Z0-9._]/g, '') })} /></Col>
            <Col><Input placeholder="Description"
                disabled={adding}
                onChange={(e: any) => setCRole({ ...crole, desc: e.target.value })} /></Col>
            <Col sm="auto"><Button size="sm" onClick={() => onRoleAdded(crole)}>Add</Button></Col>
        </Row>}
    </Container>
}

const RoleItem = ({ app = defaultApp, editable = true }) => {
    const { refreshDialog } = useUXStore(state => state)

    const onView = () => {
        refreshDialog({
            id: "roleView",
            visible: true,
            title: app.name + " Roles",
            content: <RoleListView app={app} editable={editable} />,
            className: "modal-large fixed-roles-modal",
            onConfirm: undefined,
        }, true)
    }

    return <ButtonControl text="Roles" variant="outline-primary" buttonLabel="View" onClicked={onView} />
}

export default RoleItem